import { NgModule } from '@angular/core';
import { CommonModule as AngularCommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { CommonModule } from '../common';
import { DashboardComponent } from './pages/dashboard/dashboard.component';

export const dashboardRoutes: Routes = [
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [MsalGuard],
    }
];

@NgModule({
    declarations: [DashboardComponent],
    imports: [
        AngularCommonModule,
        FormsModule,
        RouterModule,
        CommonModule,
    ]
})
export class DashboardModule {}
